import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tutorial-welcome',
  templateUrl: './tutorial-welcome.component.html',
  styleUrls: ['./tutorial-welcome.component.css']
})
export class TutorialWelcomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
